import React, { useEffect, useState } from "react";
import "./CategoriesGroupsList.scss";
import DashboardHeader from "../../../components/header/DashboardHeader";
import { IoMdArrowBack } from "react-icons/io";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import {
  avatar,
  fill_heart,
  heart_icon,
  lock_icon,
  subscription_icon,
} from "../../../assets";
import { CiSearch } from "react-icons/ci";
import { GoDotFill } from "react-icons/go";
import useDebounce from "../../../hooks/useDebounce";
import { decryptData } from "../../../utils/dataCipher";
import InfiniteScroll from "react-infinite-scroll-component";
import { GroupCardSkeleton } from "../../../shimmer/groups/GroupsListingShimmer";
import { updateFavoriteListHandler } from "../Groups/groupSubModules/LikeUnlikeHeart";
import {
  getCategoryListApi,
  getOverviewCategoryListApi,
} from "../../../services/categories";
import { toastMessage } from "../../../utils/toastMessage";
import NotFoundPlaceHolder from "../../../components/not-found/NotFoundPlaceHolder";
import FlatList from "components/FlatList";
import LazyImage from "components/common/Image";

const CategoriesGroupsList = () => {
  const [searchParam] = useSearchParams();
  const [groupList, setGroupList] = useState([]);
  const [search, setSearch] = useState("");
  const [, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const debouncedValue = useDebounce(search, 300);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  let categoryData = searchParam.get("info") || {};
  let encryptedData;
  // Get the query string (encrypted data)
  if (Object.keys(categoryData).length) {
    encryptedData = decryptData(categoryData);
  }
  // console.log('encryptedData', encryptedData)
  //---------------listing-API--------------------
  const fetchingGroupListHandler = async (page = 1, isRefresh = false) => {
    try {
      setLoading(true);
      const { data } = await getCategoryListApi({
        pagination: "true",
        search: debouncedValue,
        limit: 10,
        page: page,
        categoryName: encryptedData?.name,
      });
      const { data: groupList, success, message, meta } = data;
      if (success) {
        if (isRefresh) {
          setGroupList(groupList || []);
        } else {
          setGroupList((prev) => [...prev, ...(groupList || [])]);
        }
        setHasMore(groupList.length === 10);
      } else {
        toastMessage(message, "error", "groupListDetails");
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };
  //---------------listing-API--------------------
  const fetchingOverviewGroupListHandler = async (
    page = 1,
    isRefresh = false
  ) => {
    try {
      const { data } = await getOverviewCategoryListApi({
        pagination: "true",
        search: debouncedValue,
        limit: 10,
        page: page,
        categoryName: encryptedData?.name,
      });
      const { data: groupList, success, message, meta } = data;
      if (success) {
        if (isRefresh) {
          setGroupList(groupList || []);
        } else {
          setGroupList((prev) => [...prev, ...(groupList || [])]);
        }
        setHasMore(groupList.length === 10);
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };

  useEffect(() => {
    setPage(1);
    setHasMore(true);
    if (encryptedData?.type === "overview") {
      fetchingOverviewGroupListHandler(1, true);
    } else {
      fetchingGroupListHandler(1, true);
    }
  }, [debouncedValue]);

  const fetchMoreData = () => {
    setPage((prevPage) => {
      const nextPage = prevPage + 1;
      if (encryptedData?.type === "overview") {
        fetchingOverviewGroupListHandler(nextPage);
      } else {
        fetchingGroupListHandler(nextPage);
      }
      return nextPage;
    });
  };
  //--------navigate-details-page--------------
  const navigateDetailsPage = (id) => {
    navigate(`/dashboard/category/groups/${id}`);
  };
  return (
    <>
      <DashboardHeader title={"Overview"} />

      <div className="dashboard_pages">
        <div className="CategoriesGroupsList_parent">
          <div className="CategoriesGroupsList_header tab_button_wrap">
            <div className="tab_button">
              <Link to={-1}>
                <IoMdArrowBack className="backarrow" />
              </Link>
            </div>

            <div className="tab_button">
              <img src={encryptedData?.image || avatar} alt="" />
              <span className="tech_list_name">{encryptedData?.name}</span>
            </div>

            <div className="search_bar">
              <input
                type="text"
                className="search_input"
                placeholder="Search here"
                size="30"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <CiSearch className="search_icon" />
            </div>
          </div>

          <div id="scrollableContainer" className="CategoriesGroupsList_cards">
            {groupList?.length > 0 || loading ? (
              <InfiniteScroll
                dataLength={groupList.length}
                next={fetchMoreData}
                hasMore={hasMore}
                loader={<GroupCardSkeleton count={5} />}
                scrollableTarget="scrollableContainer"
              >
                <div className="health_hub_cards">
                  <FlatList
                    data={groupList}
                    renderItem={(data) => {
                      return (
                        <div key={data?._id} className="health_hub_img">
                          <div
                            onClick={() => navigateDetailsPage(data?._id)}
                            className="image_containerss pointer-cursor"
                          >
                            <LazyImage src={data?.coverImage} alt="" />
                            <div className="health_hub_img_text">
                              <h6>{data?.name}</h6>
                              <p>
                                {data?.newFeeds?.count > 0 ? (
                                  <>
                                    <GoDotFill className="live_dot" />
                                    {`${data?.newFeeds?.count} New Post${
                                      data?.newFeeds?.count > 1 ? "s" : ""
                                    }`}
                                  </>
                                ) : null}
                              </p>
                            </div>
                          </div>

                          <div className="health_hub_containt">
                            <span className="tag dark">
                              {data?.categoryName}
                            </span>

                            <figure className="health_hub_icons">
                              {data?.type === "SUBSCRIPTION" && (
                                <img
                                  src={subscription_icon}
                                  className="lockimg"
                                  alt=""
                                />
                              )}
                              {data?.type === "PRIVATE" && (
                                <img
                                  src={lock_icon}
                                  className="lockimg"
                                  alt=""
                                />
                              )}
                              <img
                                src={
                                  data?.favoriteGroup?.status === "ACTIVE"
                                    ? fill_heart
                                    : heart_icon
                                }
                                className="heartimg"
                                alt=""
                                onClick={() =>
                                  updateFavoriteListHandler(
                                    data?._id,
                                    setGroupList,
                                    data?.favoriteGroup?.status === "ACTIVE"
                                      ? "INACTIVE"
                                      : "ACTIVE"
                                  )
                                }
                              />
                            </figure>
                          </div>
                        </div>
                      );
                    }}
                  />
                </div>
              </InfiniteScroll>
            ) : (
              <NotFoundPlaceHolder title="No Groups available" />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoriesGroupsList;
